import moment from 'moment';

export const asMoment = (val) => {
  if (!val || !val.length) {
    return val;
  }
  const first = val[0];

  // If it's already a valid moment, return as is
  if (moment.isMoment(first) && first.isValid()) {
    return [first];
  }

  // Try to parse Date or string to moment (non-strict to support ISO and formatted strings)
  const parsed = moment(first);
  if (parsed.isValid()) {
    return [parsed];
  }

  // Fallback: return original value to avoid breaking consumers
  return val;
};
